import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Lead } from 'pages/Lead'
import { LeadForm } from 'pages/LeadForm'

import { routePaths } from './paths'

export const routes = routePaths

export const router = createBrowserRouter([
  {
    path: '',
    element: <Navigate to={routes.lead} replace />,
  },
  {
    path: routes.lead,
    element: <Lead />,
  },
  {
    path: routes.leadForm,
    element: <LeadForm />,
  },
])
